import React, { Component, useEffect } from 'react'
import isArray  from 'lodash/isArray';

import { Input } from '@vds/inputs';
import {  scrollInView } from '../../../utils/common';
import '../StreetAddress/StreetAddress.css'
import debounce from 'lodash/debounce';

class StreetAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInput: props.address && props.address.street ? props.address.street : null,
            outSideClick: false,
            errorMessage: props.billingaddressLabel && props.billingaddressLabel !=undefined ? props.billingaddressLabel :'You must enter your business address.',
            setFocus: true,
            isPersonal : props.isPersonal,
            addressLable :  props.addressLabel && props.addressLabel !=undefined ? props.addressLabel : "Enter your business address*"
        }
      
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.debouncedFn =  debounce((input) => {
            this.props.postUIEventLog({eventType: 'log', eventName: "Street Change", sectionName: "LQ", log: input});
        }, 1000);
    }


    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.props.onDropdownListDismiss(false)
        const element = document.getElementById('street-Address-Input')
        element.addEventListener('keydown',this.preventShiftTab)
        if(this.streetRef) {
            const input = this.streetRef.getElementsByTagName("input")[0];
            // setTimeout(() => {input.focus();}, 1000 );
            input.focus();
        }  
       if(this.props.selectedZipcode && window.screen.width > 1030) {
            scrollInView(".Check-Availability");
        }
    }

    preventShiftTab = (e) => {
          if(e.shiftKey && e.keyCode == 9){
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(nextProps) {
        if((nextProps.streetTermEnteredByUser !== this.props.streetTermEnteredByUser) || (!this.state.userInput && nextProps.streetTermEnteredByUser)) {
            this.setState({
                userInput: nextProps.streetTermEnteredByUser
            });
        }
        if(this.streetRef && this.props.selectedZipcode?.city !="" && !!this.props.selectedZipcode?.city && this.state.setFocus) {
            const input = this.streetRef.getElementsByTagName("input")[0];
            // input.focus();
            this.setState({setFocus:false})
        } 
    }
    
    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ outSideClick: true })
            this.props.onDropdownListDismiss(true)
            // this.props.selectThisStreetAddress(this.state.userInput)
        }
    }

    getStreetAddress = (e, eventType) => { 
        e.persist();
        this.props.onDropdownListDismiss(false)
        const userInput = e.target.value || null;
        this.props.resetDoLoopFlags();
        this.props.setDontShowUnit(false);
        // if(eventType == "paste") {
        //     setTimeout(() => { 
        //         let streetAddressFound = this.matchStreetAddress(this.state.userInput);
        //         if(!streetAddressFound) {
        //             this.props.getStreetValue(this.state.userInput);
        //             this.props.getStreetAddress(this.state.userInput);
        //         }
        //     }, 700);     
        // }

        this.setState({ userInput, outSideClick: false, isDirty: true })
        let streetAddressFound = this.matchStreetAddress(userInput);
        window.streetSelectionHandled = false;

        if(!streetAddressFound) {
            this.props.getStreetValue(userInput);
            this.props.getStreetAddress(userInput);
            this.debouncedFn(userInput);
        }
        if(this.streetRef) {
            const input = this.streetRef.getElementsByTagName("input")[0];          
            input.style.color = "#000000"
        }
    }

    matchStreetAddress = (userInput) => {
        let streetAddressFound = false;
        const {streetAddressSuggestionList} = this.props;
        if(streetAddressSuggestionList && isArray(streetAddressSuggestionList) && userInput) {
            streetAddressSuggestionList.map((value, key) => { 
                if(this.formatString(value?.disprawstr || '') === this.formatString(userInput)) {
                    this.props.onDropdownListDismiss(true)
                    if (value.ntasAddrID) {
                        value.baseAddressId = value.ntasAddrID;
                    }
                    this.props.selectThisStreetAddress(value);
                    this.props.getUnits();
                    this.setState({ outSideClick: true });
                    streetAddressFound = true;
                }
            });
        }
        return  streetAddressFound;
    }

    formatString = str => {
        return str ? str?.replace(/\s/g, '')?.replace(/,/g, '')?.toLowerCase()?.trim() : "";
    }
    
    handleSubmit = (e) => {
        e.preventDefault()
    }
    selectThisStreetAddress = (selectedStreetAddress) => { 
        console.log("selectThisStreetAddressselectThisStreetAddress0", selectedStreetAddress?.disprawstr); 
        window.streetSelectionHandled = true;
        const userInput = selectedStreetAddress?.disprawstr || null;
        this.setState({ userInput })
        this.props.onDropdownListDismiss(true)
        selectedStreetAddress.baseAddressId = selectedStreetAddress.ntasAddrID;
        this.props.selectThisStreetAddress(selectedStreetAddress);
        this.props.getUnits();
    }

    onBlurHandler = (input) => {
        if(!window.streetSelectionHandled) {
            const {streetAddressSuggestionList} = this.props; 
            if(streetAddressSuggestionList && streetAddressSuggestionList?.length === 1) {
                this.props.onDropdownListDismiss(true);
                if (streetAddressSuggestionList[0].ntasAddrID) {
                    streetAddressSuggestionList[0].baseAddressId = streetAddressSuggestionList[0].ntasAddrID;
                }
                this.props.selectThisStreetAddress(streetAddressSuggestionList[0]);
                this.props.getUnits();
            }
        }
    }

    render() {
        const streetAddressSuggestionList = this.props.streetAddressSuggestionList;
        // this.matchStreetAddress(this.state.userInput);
        const AddressSuggestionList = (!this.state.outSideClick && streetAddressSuggestionList) ? (
            <div className="Contact-section">
                <div ref={this.setWrapperRef} className="streetaddress-suggestion-list">
                    {Object.keys(streetAddressSuggestionList).map((key) => {
                        return (
                            <div className="suggestion-list-item" key={streetAddressSuggestionList[key].ntasAddrID}>
                                <span
                                    key={streetAddressSuggestionList[key].ntasAddrID}
                                    onClick={() => this.selectThisStreetAddress(streetAddressSuggestionList[key])}
                                >
                                    {streetAddressSuggestionList[key]?.disprawstr || ''}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
        ) : (
                ''
            )
            if(AddressSuggestionList) {
                this.matchStreetAddress(this.state.userInput);
            }
        return (
            <form onSubmit={this.handleSubmit} autocomplete="off"  key={this.props.addressError || this.props.lqStreetAddrError}>
            <div className="Street-Address" key={this.props.addressError || this.props.lqStreetAddrError}  >
                <div className="Street-inputbox" ref={(r) => { this.streetRef = r }}> 
                    <Input
                        autoFocus
                        key={this.props.addressError || this.props.lqStreetAddrError}
                        label={this.state.addressLable}
                        value={this.state.userInput}
                        onChange={this.getStreetAddress}
                        onPaste={ e => {this.getStreetAddress(e, "paste")}}
                        onFocus={(e) => {
                            e.target.value = '';}}
                        onBlur={(e)=> {                           
                            if(!e.target.value || e.target.value === '' || e.target.value === null){
                                e.target.value = "Eg. 123 Street Name, City, State, Zip Code";
                                return;
                            }  }}                     
                        // placeholder="123 Street Name, City, State, Zip Code"
                        name="myBrowser1"
                        width="100%"
                        error={this.props.addressError || this.props.lqStreetAddrError || false}          
                        errorText={this.state.isPersonal ? this.props.billingaddressLabel :this.props.lqStreetAddrError || this.state.errorMessage}
                        // autoFocus ={this.props.selectedZipcode.city !="" && !!this.props.selectedZipcode.city}                      
                       // autoFocus ={true}
                        id="street-Address-Input"
                        defaultValue={'Eg. 123 Street Name, City, State, Zip Code'}
                        //helperText={"Eg. 123 Street Name, City, State, Zip Code"}                   
                    />
                    <span>{AddressSuggestionList}</span>
                    {/* <span className="help-text">Type your address (without unit #) and select the one closest to your own. </span> */}
                </div>
            </div>
            </form>

        )
    }
}

export default StreetAddress
